import Vue from "vue";
//模块功能：产品详情-咨询类服务
export default Vue.extend({
    name: "advisory-service",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        contents: function () {
            return this.$t('productsdetail.consult');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/advisory-service.vue
// module id = null
// module chunks = 